import builder from '../builder';
import OfficeFileDoc from '../../streamline-icons/light/office-file-doc.svg';

export default builder('IconOfficeFileDocLight', OfficeFileDoc);
